import * as routes from '../routes';
import { NoahDevicesTabType } from './NoahDevicesTabType';

export const NoahDevicesRouteRecord: Record<NoahDevicesTabType, string> = {
	'read-outs': routes.NoahDevicesReadOutsRoute,
	rules: routes.NoahDevicesRulesRoute,
};
